<template>
    <div>
        <b-row class="mb-3">
            <b-col class="d-flex justify-content-start align-items-end" cols="6">
                <b-button
                    variant="primary"
                    @click="openModal">
                    bezahl.de Org registrieren
                </b-button>
            </b-col>
        </b-row>

        <b-modal
            v-model="isModalOpen"
            hide-footer
            size="lg"
            title="bezahl.de Organisation registrieren"
            @hide="reset">
            <div class="loading-content-container">
                <div v-if="isLoading" class="loading-overlay d-flex justify-content-center pt-5">
                    <csp-loading-indicator/>
                </div>

                <csp-desktop-info-card
                    v-if="!isLoading"
                    :cols="12"
                    :form-context="bezahlDeOrgFormContext"
                    icon="inticon-autoclaim_distribution"
                    title="bezahl.de Org"
                    @cancel-form="reset"
                    @save="saveBezahlDeOrg">
                    <b-row>
                        <csp-desktop-info-card-element
                            class="col-12"
                            :form-context="bezahlDeOrgFormContext"
                            label="Bezeichnung"
                            property="description"
                            :required="true"
                            type="text"/>

                        <csp-desktop-info-card-element
                            class="col-12"
                            :form-context="bezahlDeOrgFormContext"
                            label="bezahl.de Org-ID"
                            property="vendorId"
                            :required="true"
                            type="text"/>

                        <csp-desktop-info-card-element
                            class="col-12"
                            :form-context="bezahlDeOrgFormContext"
                            label="API-Token"
                            property="apiToken"
                            :required="true"
                            type="password"/>
                    </b-row>
                </csp-desktop-info-card>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';
    import FormContext from '@desktop/components/FormContext';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmBezahlDeOrgCreateModal',
        mixins: [FormDataMixin],
        props: {
            firmId: {
                type: Number,
                required: true,
            },
        },
        data() {
            return {
                isModalOpen: false,
                isLoading: true,
                initialFormContexts: {
                    bezahlDeOrg: new FormContext({
                        name: 'bezahlDeOrg',
                        objectId: this.firmId,
                        isAlwaysInEditMode: true,
                        handleEditModeByQuery: false,
                    }),
                },
            };
        },
        computed: {
            bezahlDeOrgFormContext() {
                return this.initialFormContexts.bezahlDeOrg;
            },
        },
        methods: {
            loadForm() {
                this.isLoading = true;

                const loadFunction = () => {
                    return firmRepository.loadBezahlDeOrgCreationForm(this.firmId);
                };

                this.loadFormData(loadFunction).finally(() => {
                    this.isLoading = false;
                });
            },
            openModal() {
                this.isModalOpen = true;
                this.loadForm();
            },
            reset() {
                this.bezahlDeOrgFormContext.form.reset();
                this.isModalOpen = false;
                this.isLoading = true;
            },
            saveBezahlDeOrg(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.createBezahlDeOrg(this.firmId, postData);
                };

                this.saveFormData(formContext, saveFunction, false).then(() => {
                    this.reset();
                    this.$emit('org-created');
                });
            },
        },
    };
</script>
